<div class="govuk-width-container d-flex">
    <a href="https://www.rbwm.gov.uk/" target="_blank" rel="noopener noreferrer" aria-label="Royal Borough of Windsor and Maidenhead (opens in new window)">
      <img src="assets/rbwm_logo_header_1.png" alt="RBWM logo" class="logo">
    </a>
    <gb-ui-header
      [imageDetail]="imageDetail"
      [navLinks]="navigation"
      [showSearch]="true"
      (searchTerm)="search($event)"
    >
      <ng-template #utilityArea>
        <div class="d-flex">
          @if (!isAdmin()) {
          <button class="btn btn-primary login" (click)="login()">
            Log in
          </button>
          }
        </div>
      </ng-template>
    </gb-ui-header>
  </div>
  